import { Helmet } from 'react-helmet-async'
import { Box } from '@mui/material'
import Header from "components/Header"
import Sidebar from "components/Sidebar"
import TestJourneysContent from './TestJourneysContent'
import styles from './styles.module.scss'

const TestJourneysLayout = () => {

    return (
        <Box className="rootWrapper">
            <Helmet>
                <title>Treegress - Test Journeys</title>
            </Helmet>
            <Header />
            <Box className="srollContent">
                <Sidebar />
                <Box className={styles.testJourneys}>
                    <TestJourneysContent />
                </Box>
            </Box>
        </Box >
    )
}

export default TestJourneysLayout